import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-compact-down', 'ChevronCompactDown', [["path",{"d":"M4 11l8 3l8 -3","key":"svg-0"}]]);